import React from 'react'

const LINK_REGEX = /(https?:\/\/[^\s<]+|www\.[^\s<]+|[\w.+-]+@[\w.-]+\.\w{2,})/gi

export function renderMessageWithLinks(text: string): React.ReactNode {
  if (!text) return text

  const parts = text.split(LINK_REGEX)
  if (parts.length === 1) return text

  return parts.map((part, i) => {
    if (!part) return null

    if (LINK_REGEX.test(part)) {
      LINK_REGEX.lastIndex = 0

      if (part.includes('@') && !part.startsWith('http')) {
        return (
          <a
            key={i}
            href={`mailto:${part}`}
            style={{ color: '#63B3ED', textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        )
      }

      const href = part.startsWith('http') ? part : `https://${part}`
      return (
        <a
          key={i}
          href={href}
          style={{ color: '#63B3ED', textDecoration: 'underline' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      )
    }

    return <React.Fragment key={i}>{part}</React.Fragment>
  })
}
